import * as React from 'react';
import FlairIcon from '../../../../atomic/atoms/FlairIcon';
import { QuickAction } from './types';

type Props = {
  quickActions: QuickAction[];
  onNavigate: (route: string) => void;
  onInlinePrompt: (text: string) => void;
};

export const MAX_CHIPS_TOTAL = 3;
export const MAX_CHIPS_PER_KIND = 2;

export function capQuickActions(actions: QuickAction[]): QuickAction[] {
  const kept: QuickAction[] = [];
  const perKind: Record<string, number> = {};
  for (const action of actions) {
    if (kept.length >= MAX_CHIPS_TOTAL) break;
    const count = perKind[action.kind] ?? 0;
    if (count >= MAX_CHIPS_PER_KIND) continue;
    perKind[action.kind] = count + 1;
    kept.push(action);
  }
  return kept;
}

const AiChatQuickActions: React.FC<Props> = ({
  quickActions,
  onNavigate,
  onInlinePrompt,
}) => (
  <div className="ai-chat-quick-actions">
    {capQuickActions(quickActions).map((action) => {
      if (action.kind === 'inline') {
        const prompt = action.promptTemplate ?? action.label;
        return (
          <button
            key={action.id}
            type="button"
            className="ai-chat-chip ai-chat-chip--inline"
            onClick={() => onInlinePrompt(prompt)}>
            <FlairIcon icon="chatbubble-ellipses-outline" size="xs" />
            <span>{action.label}</span>
          </button>
        );
      }
      return (
        <button
          key={action.id}
          type="button"
          className="ai-chat-chip ai-chat-chip--goto"
          onClick={() => onNavigate(action.route)}>
          <span>{action.label}</span>
          <span aria-hidden="true" className="ai-chat-chip__arrow">
            ↗
          </span>
        </button>
      );
    })}
  </div>
);

export default AiChatQuickActions;
